/* eslint-disable */
import React from "react";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
// @material-ui/icons
import AddAlert from "@material-ui/icons/AddAlert";
import ErrorOutlineIcon from "@material-ui/icons/ErrorOutline";
// core components
import GridItem from "components/Grid/GridItem.jsx";

import httpr from "lib/httpRequest";
import { BASE_URL, isLocal } from "../../lib/config";
import { AuthConsumer } from "react-check-auth";

import GetMemberInfo from "actions/MemberAction.jsx";

import CustomTabs from "components/CustomTabs/CustomTabs.jsx";
import Profile from "components/Members/Profile.jsx";

import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import { scColor } from "assets/jss/material-dashboard-react.jsx";
import Snackbar from "components/Snackbar/Snackbar.jsx";

import AutoReportOptions from "components/ReportOptions/AutoReportOptions.jsx";
import AlertOptions from "components/Alerts/AlertOptions.jsx";

const styles = (theme) => ({
  loading: {
    width: "100%",
  },
  dialogControl: {
    width: "100%",
  },
  cardCategoryWhite: {
    "&,& a,& a:hover,& a:focus": {
      color: "rgba(255,255,255,.62)",
      margin: "0",
      fontSize: "14px",
      marginTop: "0",
      marginBottom: "0",
    },
    "& a,& a:hover,& a:focus": {
      color: "#FFFFFF",
    },
  },
  cardTitleWhite: {
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: "3px",
    textDecoration: "none",
    "& small": {
      color: "#777",
      fontSize: "65%",
      fontWeight: "400",
      lineHeight: "1",
    },
  },
});

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const PaperProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

class UserProfile extends React.Component {
  _isMounted = false;
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      edit: false,
      tl: false,
      tc: false,
      tr: false,
      bl: false,
      bc: false,
      br: false,
      snackbarColor: "info",
      snackbarIcon: AddAlert,
      msg: "",
      showAlert: false,
      memberId: -1,
    };
    this.alertTimeout = null;
  }

  componentDidMount() {
    this._isMounted = true;
  }
  componentWillUnmount() {
    this._isMounted = false;
    this.clearAlertTimeout();
  }

  loadMemberInfo() {
    const token = localStorage.getItem("token");
    if (token !== null && token !== undefined) {
      GetMemberInfo(token)
        .then((r) => {
          if (this._isMounted === true) {
            this.setState({ loading: false, ...r });
          }
        })
        .catch((e) => {
          if (this._isMounted === true) {
            this.setState({ loading: false });
          }

          console.log(e);
        });
    }
  }

  createMember = (mem) => {
    mem.location = mem.selectedLocIds;

    const token = localStorage.getItem("token");
    const fetch = httpr(token);

    fetch
      .post(`${BASE_URL}/api/members/create`, mem)
      .then((response) => {
        this.showNotification(AddAlert, "info", response.data.message);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  deleteAction = (endpoint) => {
    const token = localStorage.getItem("token");
    const fetch = httpr(token);

    fetch
      .delete(`${BASE_URL}${endpoint}`)
      .then((response) => {
        this.showNotification(AddAlert, "info", response.data.message);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  addAction = (endpoint, param) => {
    //return
    const token = localStorage.getItem("token");
    const fetch = httpr(token);

    fetch
      .post(`${BASE_URL}${endpoint}`, param)
      .then((response) => {
        if (response.data.message.includes("already exists")) {
          this.showNotification(
            ErrorOutlineIcon,
            "danger",
            response.data.message
          );
        } else {
          this.showNotification(AddAlert, "info", response.data.message);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  editMember = (memId) => {
    this.setState({
      memberId: memId,
      edit: true,
    });
  };

  saveAlertSettings = (settings) => {
    const token = localStorage.getItem("token");
    const fetch = httpr(token);

    // Validate:
    if (settings.LocationID < 0) {
      this.showNotification(
        ErrorOutlineIcon,
        "danger",
        "A location must be selected"
      );
    } else {
      fetch
        .put(`${BASE_URL}/api/members/settings/alert`, settings)
        .then((response) => {
          if (response.data.message === "New Alert Added") {
            this.showNotification(AddAlert, "info", `${response.data.message}`);
          } else {
            this.showNotification(
              ErrorOutlineIcon,
              "danger",
              `${response.data.message}`
            );
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };

  updateAlertSettings = (ID, settings) => {
    const token = localStorage.getItem("token");
    const fetch = httpr(token);

    // Validate:
    if (settings.LocationID < 0) {
      this.showNotification(
        ErrorOutlineIcon,
        "danger",
        "A location must be selected"
      );
    } else {
      fetch
        .put(`${BASE_URL}/api/members/settings/alert/update/${ID}`, settings)
        .then((response) => {
          if (response.data.message === "Alert Updated") {
            this.showNotification(AddAlert, "info", `${response.data.message}`);
          } else {
            this.showNotification(
              ErrorOutlineIcon,
              "danger",
              `${response.data.message}`
            );
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };

  saveReportSettings = (options) => {
    const token = localStorage.getItem("token");
    const fetch = httpr(token);

    options.map((optionsByLocation) => {
      return new Promise(async (resolve, reject) => {
        fetch
          .post(`${BASE_URL}/api/members/settings/report`, {
            ...optionsByLocation,
          })
          .then((response) => {
            if (response.data.message === "New Report Added") {
              // show success message
              this.showNotification(
                AddAlert,
                "info",
                `${response.data.message}`
              );
            } else {
              this.showNotification(
                ErrorOutlineIcon,
                "danger",
                `${response.data.message}`
              );
            }
          })
          .catch((error) => {
            console.log(error);
          });
      });
    });
  };

  updateReportSettings = (ID, options) => {
    const token = localStorage.getItem("token");
    const fetch = httpr(token);

    fetch
      .put(`${BASE_URL}/api/members/settings/report/update/${ID}`, options[0])
      .then((response) => {
        if (response.data.message === "Setting Updated") {
          this.showNotification(AddAlert, "info", `${response.data.message}`);
        } else {
          this.showNotification(
            ErrorOutlineIcon,
            "danger",
            `${response.data.message}`
          );
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  saveMemberSettings = (settings) => {
    const token = localStorage.getItem("token");
    const fetch = httpr(token);

    fetch
      .put(`${BASE_URL}/api/members/settings`, settings)
      .then((response) => {
        this.showNotification(AddAlert, "info", "Saved");
      })
      .catch((error) => {
        console.log(error);
      });
  };

  saveMember = (mem) => {
    const token = localStorage.getItem("token");
    const fetch = httpr(token);

    fetch
      .put(`${BASE_URL}/api/members/update`, mem)
      .then((response) => {
        this.showNotification(AddAlert, "info", "Saved");
      })
      .catch((error) => {
        console.log(error);
      });
  };

  getKey() {
    return Math.floor(Math.random() * 100);
  }

  clearAlertTimeout = () => {
    if (this.alertTimeout !== null) {
      clearTimeout(this.alertTimeout);
    }
  };

  showNotification = (icon, color, msg) => {
    if (this._isMounted === true) {
      this.setState({
        open: false,
        edit: false,
        tc: true,
        snackbarColor: color,
        snackbarIcon: icon,
        msg,
      });
    }
  };

  handleClickOpen = () => {
    this.setState({ open: true });
  };

  handleClose = () => {
    this.setState({ open: false });
  };

  handleEditClickOpen = () => {
    this.setState({ edit: true });
  };

  handleEditClose = () => {
    this.setState({ edit: false });
  };

  handleCloseDialog = () => {
    this.setState({ showAlert: false });
  };

  render() {
    return (
      <div>
        <Snackbar
          place="tc"
          color={this.state.snackbarColor}
          icon={this.state.snackbarIcon}
          message={this.state.msg}
          open={this.state.tc}
          closeNotification={() => this.setState({ tc: false })}
          close
        />
        <AuthConsumer>
          {({ isLoading, userInfo, error }) => {
            if (!userInfo) {
              return <div />;
            }

            let MemberId = -1;
            let member = null;
            let Locations = [];

            if (userInfo) {
              MemberId = userInfo.MemberId;
              member = userInfo.member;
              Locations = member.Locations.filter(
                (location) => location.OrganizationId !== 0
              );
              
              // Add license information to each location - match Reports.jsx pattern
              if (member.LocationLicenses && member.LocationLicenses.length > 0) {
                Locations = Locations.map(location => {
                  // Find license data for this location - match DashboardTabs pattern
                  const licenseData = member.LocationLicenses.find(
                    loc => loc.locationId === location.LocationId
                  );
                  
                  // Add license information to the location object
                  return {
                    ...location,
                    license: licenseData ? licenseData.license : {
                      isValid: 1, // Treat null/missing license as valid
                      daysUntilExpiration: null,
                      expirationDate: null
                    }
                  };
                });
              } else {
                // If no license data available, treat as valid license
                Locations = Locations.map(location => ({
                  ...location,
                  license: {
                    isValid: 1, // Treat missing license data as valid
                    daysUntilExpiration: null,
                    expirationDate: null
                  }
                }));
              }
            }

             if (isLocal === true || isLocal === "true") {
               return  (
                <GridItem xs={12} sm={12} md={12}>
                <CustomTabs
                  key={MemberId}
                  title=""
                  subtitle="Locations:"
                  headerColor="scmain"
                  tabs={[
                    {
                      tabName: `Member Info`,
                      tabContent: (
                        <Profile
                          key={this.getKey()}
                          member={member}
                          Locations={Locations}
                          saveMember={this.saveMember}
                          showNotification={this.showNotification}
                          deleteAction={this.deleteAction}
                          addAction={this.addAction}
                          dataUrl="/api/members/"
                        />
                      ),
                    },
                    {
                      tabName: `Error Settings`,
                      tabContent: (
                        <AlertOptions
                          key={this.getKey()}
                          multiple={false}
                          member={member}
                          type="error"
                          saveAlertSettings={this.saveAlertSettings}
                          updateAlertSettings={this.updateAlertSettings}
                          dataUrl="/api/members/settings/alert/error"
                          Locations={Locations}
                        />
                      ),
                    },
                    {
                      tabName: `Threshold Settings`,
                      tabContent: (
                        <div key={this.getKey()}>
                          <AlertOptions
                            multiple={false}
                            member={member}
                            type="threshold"
                            saveAlertSettings={this.saveAlertSettings}
                            updateAlertSettings={this.updateAlertSettings}
                            reportOptionButton={this.reportOptionButton}
                            dataUrl="/api/members/settings/alert/threshold"
                            AlertSettings={userInfo}
                            Locations={Locations}
                          />
                        </div>
                      ),
                    },
                    {
                      tabName: `Open Till Settings`,
                      tabContent: (
                        <AlertOptions
                          key={this.getKey()}
                          multiple={false}
                          member={member}
                          type="openTill"
                          saveAlertSettings={this.saveAlertSettings}
                          updateAlertSettings={this.updateAlertSettings}
                          dataUrl="/api/members/settings/alert/openTill"
                          AlertSettings={userInfo}
                          Locations={Locations}
                        />
                      ),
                    },
                    {
                      tabName: `Auto Report Settings`,
                      tabContent: (
                        <div key={this.getKey()}>
                          <AutoReportOptions
                            Locations={Locations}
                            multiple={true}
                            member={member}
                            saveReportSettings={this.saveReportSettings}
                            updateReportSettings={this.updateReportSettings}
                            token={userInfo.token}
                          />
                        </div>
                      ),
                    },
                  ]}
                />
              </GridItem> 
            )
          } else {
            return (
              <GridItem xs={12} sm={12} md={12}>
              <CustomTabs
                key={MemberId}
                title=""
                subtitle="Locations:"
                headerColor="scmain"
                tabs={[
                  {
                    tabName: `Member Info`,
                    tabContent: (
                      <Profile
                        key={this.getKey()}
                        member={member}
                        Locations={Locations}
                        saveMember={this.saveMember}
                        showNotification={this.showNotification}
                        deleteAction={this.deleteAction}
                        addAction={this.addAction}
                        dataUrl="/api/members/"
                      />
                    ),
                  },
                  {
                    tabName: `Error Settings`,
                    tabContent: (
                      <AlertOptions
                        key={this.getKey()}
                        multiple={false}
                        member={member}
                        type="error"
                        saveAlertSettings={this.saveAlertSettings}
                        updateAlertSettings={this.updateAlertSettings}
                        dataUrl="/api/members/settings/alert/error"
                        Locations={Locations}
                      />
                    ),
                  },
                  {
                    tabName: `Replication Settings`,
                    tabContent: (
                      <AlertOptions
                        key={this.getKey()}
                        multiple={false}
                        member={member}
                        type="replication"
                        saveAlertSettings={this.saveAlertSettings}
                        updateAlertSettings={this.updateAlertSettings}
                        dataUrl="/api/members/settings/alert/replication"
                        AlertSettings={userInfo}
                        Locations={Locations}
                      />
                    ),
                  },
                  {
                    tabName: `Threshold Settings`,
                    tabContent: (
                      <div key={this.getKey()}>
                        <AlertOptions
                          multiple={false}
                          member={member}
                          type="threshold"
                          saveAlertSettings={this.saveAlertSettings}
                          updateAlertSettings={this.updateAlertSettings}
                          reportOptionButton={this.reportOptionButton}
                          dataUrl="/api/members/settings/alert/threshold"
                          AlertSettings={userInfo}
                          Locations={Locations}
                        />
                      </div>
                    ),
                  },
                  {
                    tabName: `Open Till Settings`,
                    tabContent: (
                      <AlertOptions
                        key={this.getKey()}
                        multiple={false}
                        member={member}
                        type="openTill"
                        saveAlertSettings={this.saveAlertSettings}
                        updateAlertSettings={this.updateAlertSettings}
                        dataUrl="/api/members/settings/alert/openTill"
                        AlertSettings={userInfo}
                        Locations={Locations}
                      />
                    ),
                  },
                  {
                    tabName: `Auto Report Settings`,
                    tabContent: (
                      <div key={this.getKey()}>
                        <AutoReportOptions
                          Locations={Locations}
                          multiple={true}
                          member={member}
                          saveReportSettings={this.saveReportSettings}
                          updateReportSettings={this.updateReportSettings}
                          token={userInfo.token}
                        />
                      </div>
                    ),
                  },
                ]}
              />
            </GridItem> 
            )
          }
          }}
        </AuthConsumer>
      </div>
    );
  }
}

export default withStyles(styles)(UserProfile);



// WEBPACK FOOTER //
// ./src/views/UserProfile/UserProfile.jsx